define('controllers/aplpromote/apl-promote-select.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('aplPromoteSelect', ['$scope', '$state', 'UserInfo', 'auiDialog','OpenUp','UserInfoPreload',
        function ($scope, $state, UserInfo, auiDialog,OpenUp,UserInfoPreload) {
            $scope.hasHAGWhite = false;
            $scope.showNewPromotePage = showNewPromotePage;
            $scope.goTaskList = goTaskList;
            $scope.goHagWidgetList = goHagWidgetList;
            $scope.isProxyRole = false;
            //系统用户角色配置
            var roleTypeCfg = systemParaConf.roleType;
            var Model = $scope.Model={};
            Model.UserInfoPreload = UserInfoPreload;
            function init() {
                UserInfo.promise().then(function () {
                    // 确定是否需要提示新手指引
                    UserInfo.getUserRouteInfo().then(function (data) {
                        // 有开发者角色，才显示新手指引
                        if (data.roleList && angular.isArray(data.roleList) && AUI.BaseJSUtil.contains(data.roleList, roleTypeCfg.PopProxy)) {
                        	$scope.isProxyRole=true;
                        }else{
                        	$scope.isProxyRole=false;
                        }
                    });
                });
            }
            init();
            /**
             *  打开新的应用推广页面
             */
            function showNewPromotePage() {
                AUI.BaseJSUtil.redirectUrlByBlank(sysUrlCfg.newPromotePage);
            }

            /**
             * 跳转到云文件夹推广任务页面
             */
            function goTaskList() {
                if(Model.UserInfoPreload.verifyRealState == 2){
                    $state.go('aplPromoteCFList');
                }else{
                    auiDialog.warn("您的实名认证信息正在审核中，审核通过后，您才可以使用云文件夹推广服务。");
                }

            }

            /**
             * 跳转到直达服务列表页面
             */
            function goHagWidgetList() {
                if ($scope.hasHAGWhite) {
                    $state.go('hagWidgetList',{appID:''});
                }
                else {
                    var content = '欢迎您使用HAG服务，请按照如下格式发送邮件' +
                        '至 hagservice@huawei.com申请开通 ,审核周期为1-2个工作日。';
                    auiDialog.warn( '温馨提醒',content, function () {
                    },{
                        content1:'邮件主题：HAG服务权限申请_开发者联盟帐号',
                        content2:'邮件正文：请注明您的服务名称、服务简介'
                    });
                }
            }
        }
    ]);
});
